import React from 'react';
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import { getResponsiveSize } from 'utils/index';

import NewGradientButton from 'components/Button/NewGradienteButton';
import { ResetPinConfirmModalProps } from 'components/Pin/ResetPinConfirmModal';
import IsLoading from 'components/isLoading';

export const WebResetPinConfirmModal = ({
  isOpen,
  isLoading,
  onConfirm,
  onCancel,
}: ResetPinConfirmModalProps): React.ReactNode => {
  if (!isOpen) return null;

  if (isLoading) {
    return (
      <View style={styles.loadingOverlay}>
        <View style={styles.overlay}>
          <IsLoading />
        </View>
      </View>
    );
  }

  return (
    <Modal visible={isOpen} transparent animationType="fade">
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>Redefinir PIN</Text>

          <Text style={styles.text}>Tem certeza de que deseja redefinir seu PIN?</Text>
          <Text style={styles.text}>Um novo PIN será gerado e enviado para seu e-mail.</Text>

          <View style={styles.buttons}>
            <NewGradientButton style={styles.confirmBtn} onPress={onConfirm}>
              <Text style={styles.confirmBtnText}>Redefinir</Text>
            </NewGradientButton>

            <Pressable accessibilityRole="button" style={styles.cancelBtn} onPress={onCancel}>
              <Text style={styles.cancelBtnText}>Cancelar</Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
    zIndex: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlay: {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.85)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: Number(getResponsiveSize({ base: 16, md: 24 })),
  },
  container: {
    width: '90%',
    maxWidth: 600,
    padding: Number(getResponsiveSize({ base: 20, md: 40 })),
    backgroundColor: '#050923',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#182DB3',
  },
  loading: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: Number(getResponsiveSize({ base: 24, md: 32 })),
    fontWeight: '700',
    color: '#7A8CFF',
    textAlign: 'center',
    marginBottom: Number(getResponsiveSize({ base: 16, md: 24 })),
  },
  text: {
    color: '#FFF',
    fontSize: Number(getResponsiveSize({ base: 16, md: 20 })),
    textAlign: 'center',
  },
  buttons: {
    alignItems: 'center',
    marginTop: Number(getResponsiveSize({ base: 32, md: 48 })),
  },
  confirmBtn: {
    height: Number(getResponsiveSize({ base: 44, md: 54 })),
    width: '100%',
    maxWidth: 300,
  },
  confirmBtnText: {
    fontSize: Number(getResponsiveSize({ base: 16, md: 20 })),
    fontWeight: '600',
    color: '#070D31',
  },
  cancelBtn: {
    width: '100%',
    maxWidth: 186,
    height: Number(getResponsiveSize({ base: 44, md: 54 })),
    justifyContent: 'center',
    alignItems: 'center',
  },
  cancelBtnText: {
    color: '#FFF',
    fontSize: Number(getResponsiveSize({ base: 16, md: 18 })),
  },
});
